import type { FormObject } from '@ab-core/functions/formValidation';
import { getArrayFromFields } from '@ab-core/functions/formValidation';

export const availabilities: FormObject['fields'] = {
    showPickupChannels: {
        inputProps: {
            checked: true,
            required: false,
            label: 'Weitere Niederlassungen anzeigen'
        }
    }
};

export const additionalInfos: FormObject['fields'] = {
    positionText: {
        inputProps: { checked: true, required: false, label: 'Positionstext anzeigen' }
    },
    comparison: { inputProps: { checked: true, required: false, label: 'Artikel vergleichen anzeigen' } },
    packagingSize: { inputProps: { checked: true, required: false, label: 'Verpackungseinheit anzeigen' } },
    additionalLinks: {
        inputProps: {
            checked: true,
            required: false,
            label: 'Alternativen und Zubehör anzeigen'
        }
    }
};

export const prices: FormObject['fields'] = {
    showUvpWithoutVat: {
        inputProps: {
            checked: true,
            required: false,
            label: 'UVP Netto anzeigen'
        }
    },
    showUvpWithVat: {
        inputProps: { checked: true, required: false, label: 'UVP Brutto anzeigen' }
    },
    showSurcharges: {
        inputProps: { checked: true, required: false, label: 'Zuschläge anzeigen' }
    }
};

export const filterAvailabilities = getArrayFromFields(availabilities).map((a) => a.key);

export const filterPrices = getArrayFromFields(prices).map((a) => a.key);

export const filterAdditionInfos = getArrayFromFields(additionalInfos).map((a) => a.key);
